:host {
  position: relative;
  display: grid;
}

@include dialogAnimation(dialog, false);

@include media-max('md') {
  @include dialogAnimation(dialog, true);
}

dialog {
  position: absolute;
  top: 1px;
  margin-top: 0;
  width: 100%;
  max-width: var(--header-max-width);
  box-sizing: border-box;
  border: none;
  background-color: $color-white;
  box-shadow: 0px 20px 20px 0px rgba(80, 110, 129, 0.25);
  padding: 0;
  height: fit-content;

  @include media-min('xl') {
    top: -48px;
  }

  &::backdrop {
    opacity: 0;
  }

  @include media-max('lg') {
    position: fixed;
    top: var(--header-height);
    bottom: 0;
    height: auto;
    overflow: auto;
  }
}

.dialog-body {
  padding-block: 24px 64px;
}

.dialog-content {
  box-sizing: border-box;
  max-width: 1200px;
  padding: 0 15px;
  margin-inline: auto;
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: row;
  grid-template-rows: [btn-back-start] auto [btn-back-end] 32px [title-start] auto [title-end] 32px [content-start] auto [content-end] 24px [cta-start] auto [cta-end];

  @include media-min('md') {
    grid-template-rows: [btn-close-start] auto [btn-close-end] 32px [title-start] auto [title-end] 32px [content-start] auto [content-end] 24px [cta-start] auto [cta-end];
  }

  @include media-min('lg') {
    grid-template-rows: [title-start] auto [title-end] 24px [content-start] auto [content-end] 24px [cta-start] auto [cta-end];
  }
}

#close-icon {
  grid-area: btn-close;
  grid-column: 1 / -1;
  margin-left: auto;

  @include media-min('lg') {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.back-button {
  grid-area: btn-back;
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 8px;
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  @include font-style('mid-size-text');
  color: $color-dark-blue-02;
  width: fit-content;

  &:focus-visible {
    outline: 2px solid $color-focus;
  }
}

.title-wrapper {
  grid-area: title;
  grid-column: 1 / -1;
}

.content-wrapper {
  grid-area: content;
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @include media-min(lg) {
    gap: 30px;
    grid-template-columns: repeat(3, 1fr);
  }
}

.cta-wrapper {
  grid-area: cta;
  grid-column: 1 / -1;
}
